@if (!isLoaded) {
  <div class="alert alert-info">{{ 'loading' | translate }}</div>
}
<div [ngClass]="{ noVisibility: !isLoaded }">
  <div class="row">
    <div class="col-md-12 d-flex">
      <span class="d-flex justify-content-between align-items-center">
        <h5 class="iscan__batch__title me-3">{{ 'iScan.globalInfos.scanList' | translate }}</h5>
        <span class="iscan__batch__selectAll" (click)="selectUnselectAllCards()"
          ><i class="bi bi-arrows-vertical"></i>{{ selectUnselectCardsTooltip() }}</span
        >
      </span>
    </div>
    @for (cardInfo of displayedDatas; track cardInfo; let i = $index) {
      <div class="col-md-4 mb-4">
        <p-card styleClass="card__background--light">
          <ng-template pTemplate="header">
            <div class="card__header">
              <div class="d-flex align-items-center">
                <p-checkbox *ngIf="cardInfo.idCourrierFile" binary="true" class="me-2" [(ngModel)]="cardInfo.isChecked"></p-checkbox>
                <span class="cursor--pointer" (click)="cardInfo.idCourrierFile ? modifyListOfCheckedCards(i) : null"
                  >{{ 'iScan.globalInfos.scan' | translate }} {{ cardInfo.courrierIndex }}</span
                >
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="content">
            <p class="m-0">
              <b>{{ 'global.courrierId' | translate }}</b> :
              <span [ngClass]="{ 'text-danger': !cardInfo.idCourrierFile }">{{
                cardInfo.idCourrierFile ?? ('iScan.information.noiCourrierFileIDFound' | translate)
              }}</span>
            </p>
          </ng-template>
        </p-card>
      </div>
    }
  </div>
  <div class="d-flex justify-content-end">
    <i-button styleClass="red me-2" (click)="emitCloseModal()" [text]="'cancel' | translate"></i-button>
    <i-button
      styleClass="green"
      [disabled]="!isAnyScanSelected()"
      [text]="'save' | translate"
      [loading]="submitAttachmentLoader"
      (click)="submitAttachMass()"></i-button>
  </div>
</div>
